let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hdQ3n")).then(() => parcelRequire('gZWG2'));